const labels = Object.freeze({
  HOME: 'Home',
  MY_ACTIONS: 'My Actions',
  MANAGE_DIGITAL_ASSETS: 'Manage Digital Assets',
  CONTACTS: 'Contacts',
  UPDATE_CONTACT_INFO: 'Update Contact Information',
  CONTACT_INFO: 'Contact Information',
  USER_DETAILS: 'User Details',
  GET_STARTED: 'Get started',
  LEARN_MORE: 'Learn more',
  UPDATE_PASSWORD: 'Update Password',
  ACTIVATE_FXACCOUNT: 'Activate FileX Account',

  TRANSMITTER_NM: 'Transmitter Name',
  AMEX_CONTACT: 'Amex Contact',
  PROTOCOL: 'Protocol',
  LAST_PWD_CHANGED_TIME: 'Last Password Changed Time',
  STATUS: 'Status',
  ENVIRONMENT: 'Environment',

  ROLE: 'role',

  NAME: 'Name',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password',

  CONTACT_NM: 'Contact Name',
  CONTACT_TYPE: 'Contact Type',
  CONTACT_EMAIL: 'Email Address',
  CONTACT_TYPE_TOOLTIP: 'Contact Type is read-only and cannot be changed',
  EMAIL_TOOLTIP: 'Email Address is read-only and cannot be changed',

  DATE: 'Date',
  REQUEST_ID: 'Request ID',
  ACTION: 'Action',
  FX_ACCOUNT_NAME: 'FileX Account Name',
  DIGITAL_ASSETS_GROUP: 'Digital Assets Group',
  RAISED_ON: 'Raised On',
  FX_ACCOUNT: 'FileX Account',
  AMEX_OWNED_ASSETS: 'Amex Owned Assets',
});

export default labels;
